import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import fnCommon from '@/utils/fn_common';
import SkeletonBox from '@/components/common/SkeletonBox.vue';
import ResizeSensor from 'resize-sensor';
import LoadScript from 'vue-plugin-load-script';
import vueAlerts from 'vue-alerts';
import BrowserDetector from 'browser-dtector';

const detector = new BrowserDetector(window.navigator.userAgent);
const userAgent = detector.parseUserAgent();
window.ResizeSensor = ResizeSensor;

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['skeleton-el'];
// Vue.config.devtools = true; // Vue devtools 사용시 주석 해제

Vue.use(fnCommon);
Vue.component('SkeletonBox', SkeletonBox);

Vue.use(LoadScript);

Vue.use(vueAlerts, {
  developerMode: true,
  presentBlockTime: 100,
  dismissBlockTime: 100,
});

Vue.mixin({
  computed: {
    serverDomain() {
      let domain = process.env.NODE_ENV == 'development' ? location.protocol + '//' + location.hostname + ':9000' : '';
      return domain;
    },
    currentRouteType() {
      return this.$route.meta?.type;
    },
    pgDiv() {
      return this.currentRouteType === 'ind' ? 'P' : this.currentRouteType === 'grp' ? 'G' : '';
    },
    groupPersDiv() {
      return this.pgDiv === 'P' ? '02' : '01'; //개인 02, 단체 01
    },
    isMobileSafari() {
      return (userAgent.isMobile && userAgent.name === 'Safari') || userAgent.platform === 'IPad';
    },
  },
  methods: {
    _priceFormat(price = 0) {
      return price.toLocaleString();
    },
    _wonFormat(price, df = '0원') {
      return price ? price.toLocaleString() + '원' : df;
    },
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
